import { PrivateInterceptor } from "../../../interceptors/PrivateInterceptor";

// OBTENER SESIONES MAS RECIENTES
export const getSesiones = async() => {
    const respuesta = await PrivateInterceptor(`Base/IT/Sesion`, 'GET')
    return respuesta;
}